import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpService } from '@akeela/properties';
import { isNullOrUndefined } from 'util';
import {
  AkeelaWorkflowService,
  AkeelaStageService,
  AkeelaStepService,
  AkeelaSectionService
} from '@akeela/workflow';
import swal from 'sweetalert2';
import { I18nPipe } from '@akeela/i18n';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalService } from '@akeela/local-storage';
import { Table, Row, Column } from '@akeela/ak-table';
import { AuthService } from '@akeela/auth';




@Component({
  selector: 'app-section-bank-account-other-institution',
  templateUrl: './section-bank-account-other-institution.component.html',
  styleUrls: ['./section-bank-account-other-institution.component.css']
})
export class SectionBankAccountOtherInstitutionComponent implements OnInit, OnDestroy {
  workflow;
  stage;
  step;
  transactionNumber;
  transactionData;
  itemList: any;
  queryParams;
  active_redirect = false;
  checkDoNotHaveBankAccount = false;
  showLoading = true;
  readonlyMode = false;

  subscriptor_transaction: Subscription;
  workflow_event_suscriptor: Subscription;
  accountType = [];
  role;


  loading_table = false;
  configuration_table: Table;
  paramsSubscription: Subscription;
  clientIdentifier;

  constructor(
    public _httpService: HttpService,
    private akeelaWorkflowService: AkeelaWorkflowService,
    private akeelaStageService: AkeelaStageService,
    private akeelaStepService: AkeelaStepService,
    private route: ActivatedRoute,
    private akeelaSectionService: AkeelaSectionService,
    private i18n: I18nPipe,
    private localStorage: LocalService,
    public _auth:AuthService

  ) { }

  ngOnInit() {
    this.clientIdentifier = this.localStorage.getItem('clientIdentifier');
    this.akeelaWorkflowService.worflowEvents$.next(null);
    this.workflow = this.akeelaWorkflowService.currentWorkflow$.getValue();
    this.stage = this.akeelaStageService.currentStage$.getValue();
    this.step = this.akeelaStepService.currentStep$.getValue();
    this.transactionNumber = this.akeelaWorkflowService.transactionNumber$.getValue();
    this.transactionData = this.akeelaWorkflowService.transactionData$.getValue();
    this.role = this.localStorage.getItem('role');


    this.akeelaStepService.currentStepMode$.subscribe((readonly) => {
      this.readonlyMode = readonly;
    });






    this.paramsSubscription = this.route.queryParams.subscribe(queryParams => {
      this.queryParams = queryParams;
    });

    if (this.workflow_event_suscriptor) {
      this.workflow_event_suscriptor.unsubscribe();
    }
    this.workflow_event_suscriptor = this.akeelaWorkflowService.worflowEvents$.subscribe((response: any) => {
       
      if (!isNullOrUndefined(response)) {
        if (response && response.action === 'briefcase$bank_account$put' || response && response.action === 'account_opening$bank_account$put' ) {
          this.getItemList();
        } else if (response && response.action === 'showLoadingBankWithInstitution') {

          let values = !response.value? true:false;

          this.setCheckDoNotHaveBankAccount(!values);
  
          if (values) {
            this.getItemList();
          }

        } 
      }
    });

    this.getAccountType();
    this.getItemList();

  }


  getAccountType() {
    const params = {
      name: 'workflow_manager$attributes_options$get',
      params: {
        request: {},
        path: {
          code: 'accountType'
        },
        body: {}
      }
    };
    
    this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {
      let nameItem = '';
      if(response.length){
        this.accountType = [];
        for (const value of response) {
          nameItem = value.item.alternateName;
          this.accountType[nameItem] = value.name;

        }}});
    
  }

  sendEventToContinue(response) {
    this.akeelaWorkflowService.worflowEvents$.next({
      response: {
        fn: response.fn,
        event: event,
        sectionIdentifier: response.sectionIdentifier,
        field: response.field
      },
      action: 'receive_formValidationEvent'
    });
  }



  destroyTransactionDataSubscription() {
    if (this.subscriptor_transaction) {
      this.subscriptor_transaction.unsubscribe();
    }
    if (this.workflow_event_suscriptor) {
      this.workflow_event_suscriptor.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.destroyTransactionDataSubscription();
    if (this.workflow_event_suscriptor) {
      this.workflow_event_suscriptor.unsubscribe();
    }
    if (this.paramsSubscription) {
      this.paramsSubscription.unsubscribe();
    }
  }


  setShowLoading(value: boolean) {
    this.showLoading = value;
  }

  setCheckDoNotHaveBankAccount(value: boolean) {
    this.checkDoNotHaveBankAccount = value;
  }

  getItemList() {
    const params = {
      name: 'briefcase$person_bank_accounts$get',
      params: {
        request: {
          otherInstitution: true,
          idPerson: this.clientIdentifier,

        },
        path: {
        },
        body: {}
      }
    };
    this.setShowLoading(true);
    this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {

      this.setShowLoading(false);
      this.itemList = response;
      this.setConfigurationTable();
      this.akeelaWorkflowService.setResetEstatus(true);

    });
  }

  openItem(row) {
    row = Object.assign({currency:{alternateName: "BS"}}, row);
    this.akeelaSectionService.addModalSection({ name: 'BANKING_PROD_OTHER_INSTITUTION_MODAL' });
    this.akeelaSectionService.showModalSection('BANKING_PROD_OTHER_INSTITUTION_MODAL');
    this.akeelaSectionService.setModalFormValue('BANKING_PROD_OTHER_INSTITUTION_MODAL', {});
    this.akeelaSectionService.setModalFormValue('BANKING_PROD_OTHER_INSTITUTION_MODAL', row);
  }

  confirmDelete(row: any) {
    swal.fire({
      title: this.i18n.transform('@i18n-popup-text-delete-question'),
      text: this.i18n.transform('@i18n-popup-text-delete-question-text'),
      showCancelButton: true,
      confirmButtonText: this.i18n.transform('@i18n-popup-text-yes'),
      cancelButtonText: this.i18n.transform('@i18n-popup-text-no'),
      reverseButtons: true
    }).then((result) => {
      if (!isNullOrUndefined(result.value) && result.value) {
        this.deleteItem(row);
      }
    });
  }

  deleteItem(row: any) {
    const configuration = {
      name: 'briefcase$bank_account$delete',
      params: {
        path: {

        },
        request: {
          audience: this.queryParams.audience,
          role: this.queryParams.role,
          step:this.step

        },
        body: {
          accountNumber: row.accountNumber,
          person: {
            identifier: this.clientIdentifier
          }
        }
      }
    };

    this._httpService.executeRequest(configuration.name, configuration.params).subscribe((response) => {
      swal.fire({
        title: this.i18n.transform('Éxito'),
        html: this.i18n.transform('@i18n-text-information-deleted')
      });
      this.updateList('briefcase$bank_account$put');
      this.akeelaWorkflowService.setResetEstatus(true);

    }, error => {
     
    });
  }


  updateList(action: string) {
    this.akeelaWorkflowService.worflowEvents$.next({
      response: {},
      action: action
    });
  }


  /**tabla */
  
  setConfigurationTable() {
    const base: Column[] = this.setHeadTable();
    this.configuration_table = {
      cssCustom: '',
      width: '100%',
      header: {
        cssCustom: 'class-color-title-table-section',
        rows: [{
          backgroundColor: '#fff',
          columns: base
        }],
      },
      body: {
        cssCustom: '',
        rows: this.setContentTable(base)
      },
      footer: {
        cssCustom: '',
        rows: []
      }
    };
    
  }

  setHeadTable(){
    
    const base: Column[] = [
      {
        alignContent: 'left',
        fixed: 'right',
        maxWidth: '200',
        minWidth: '100',
        html: 'Institución Bancaria',
        cssCustom: '',
        enableRightBorder: true

      },
      {
        alignContent: 'left',
        fixed: false,
        maxWidth: '200',
        minWidth: '100',
        html: 'Nombre del Producto',
        cssCustom: '',

      }
      ,  
      {
        alignContent: 'left',
        fixed: false,
        maxWidth: '200',
        minWidth: '100',
        html: ' Número de Producto',
        cssCustom: ''
      },
      {
        alignContent: 'center',
        fixed: false,
        maxWidth: '20',
        minWidth: '20',
        html:'',
        cssCustom: ''
      },
      {
        alignContent: 'center',
        fixed: 'left',
        maxWidth: '20',
        minWidth: '20',
        html:'',
        cssCustom: ''
      }
  ]
    return base;
  }
  
  setContentTable(configuration): Row[] {
    let content: Row[] = [];
    let i = 0;
    for (const row of  this.itemList) {
      i++;
      content = [...content,
        {
          identifier: row,
          cssCustom: '',
          enabled: true,
          columns: [
              this.setRowContentTable({

                configuration,
                number:0,
                html: row.provider.name,
                cssCustom:'ak-tabled-row-active text-capitalize'
            
              }), 

              this.setRowContentTable({
                configuration,
                number:1,
                html:this.i18n.transform(this.accountType[row.bankAccountType]),
              }),  

              this.setRowContentTable({
                configuration,
                number:2,
                html:row.accountNumber,
              }),  
              this.setRowContentTable({

                configuration,
                number: 3,
                html: 'Ver',
                cssCustom: 'ak-tabled-row-active text-capitalize'
    
              }),

              this.setRowContentTable({
                configuration,
                number:3,
                html: '<i class="fa fa-trash" title="Eliminar" aria-hidden="true"></i>',
                click: 'delete_item',
              })
          ]
        }
      ];
    }
    return content;
  }







  setRowContentTable(row){
    
    let configuration = row.configuration;
    let number = row.number;
    let html = row.html;
    let click = row.click?row.click:null ;
    let dropdown = row.dropdown?row.dropdown:null ;
    let cssCustom = row.cssCustom?row.cssCustom:configuration[number].cssCustom;


let result = {
      
      alignContent: configuration[number].alignContent,
      fixed: configuration[number].fixed,
      maxWidth: configuration[number].maxWidth,
      minWidth: configuration[number].minWidth,
      html: html,
      click:click,
      dropdown:dropdown,
      cssCustom: cssCustom,
      enableLeftBorder: !isNullOrUndefined(configuration[number].enableLeftBorder) ? configuration[number].enableLeftBorder : false,
      enableRightBorder: !isNullOrUndefined(configuration[number].enableRightBorder) ? configuration[number].enableRightBorder : false
    }
  
return result;

  }

  table_response(response) {

    if (response.action === 'open') {
      this.openItem(response.object.identifier);

    }else if (response.action === 'action') {
       if (response.object.action === 'delete_item' && !this.readonlyMode) {

        this.confirmDelete(response.object.obj.identifier);
      }
    }
  }

}


